import React from 'react';
import './App.css';

import getConfig from './utils/getConfig';
import AdvancedCalculator from './views/AdvancedCalculator';
import SimpleCalculator from './views/SimpleCalculator';

function App() {
  const config = getConfig();
  return (
    <div className="App">
      {config.mode === 'advanced' && <AdvancedCalculator />}
      {config.mode === 'simple' && <SimpleCalculator />}
    </div>
  );
}

export default App;
